<template>
  <div class="osBody">

     <div class="osTree" v-show="IfShow === 0">
    <el-tree
     :data="osData"
     accordion
  :props="defaultProps"
  ref="tree"
  show-checkbox
  v-loading="loading" 
  @check-change="chooseNode"
  @check="checkL"
        class="ElTree">
        </el-tree>
        <div class="TreeDiv" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
    <div class="osTreeOne" v-show="IfShow === 1">
       <div class="TreeDivOne" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pollingTree",
  data() {
    return {
      loading: true,
      osData: [],
      AllDate:"",
   defaultProps: { children: 'children', label: 'label',isLeaf: 'leaf',},
   
      ImgSrc:require('../../assets/images/zuo@3x.png'),
      TreeNum:1,
      IfShow:0,
    }
  },
  methods: {
            TreeD(){
      if(this.IfShow >= 1 ) {
        this.IfShow = 0
        this.ImgSrc=require('../../assets/images/zuo@3x.png')
      } else{
        this.IfShow ++
        this.ImgSrc=require('../../assets/images/shouhui@3x.png')
      }
    },
    checkL(checkedNodes,checkedKeys,halfCheckedNodes,halfCheckedKeys){
      this.$emit('ReportTreeS',checkedKeys.checkedNodes)
    },
    chooseNode(data, checked) {
     if(checked == true){
       if(data.orgId != null){
         this.$emit('ReportTree',data)
        //  this.$emit('ReportTreeS',obj)
       }
      }else{
      
      }
    },
    getUserOffice() {
      this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
        let data = res.data.data;
         if(res.data.code == 200){
        for(let val of data){
            if(val.children !=null){
                for(let res of val.children){
                    delete res.children
                }
            }
        }
          this.osData = data
          this.loading=false
        }else{
          this.$message.error(data.msg)
          this.loading=false
        }
      }).catch(() => {
        this.loading=false
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
  },
  mounted() {
    this.getUserOffice();
  }
}
</script>

<style scoped lang="scss">
.osBody {
  height: 700px;
  float: left;
  margin-right:1% ;
  margin-top: -14px;
  .osTree{
    width: 220px;
    height: 700px;
    position: relative;
  }
  .osTreeOne{
    width: 20px;
    height: 700px;
    position: relative;
  }
}
.TreeDiv{
  width: 20px;
  height: 60px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  right: -17px;
}
.TreeDivOne{
    width: 25px;
  height: 70px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  left:-3px;
}

.ElTree{
  z-index: 500;
  height: 700px;
  overflow-x:scroll;
}
</style>